import { hbs } from 'ember-cli-htmlbars';
export default hbs('<div class=\"cCA--boardWrapper\">\n  <Shared::LoadingSpinner />\n</div>', { moduleName: 'later/templates/cluster/schedule/loading.hbs' });
